import { useState } from "react";
import { disableBookingDate } from "../APIs/api-routes.util";
import { ApiMessageResponse } from "../APIs/api.types";
import { Alert } from "./ui/Alert";
import { Button } from "./ui/Button";
import { Input } from "./ui/Input";
import { Modal, ModalFooter } from "./ui/Modal";
import { apiSubscribe } from "../lib/api-subscribe";

interface QuickDisableDayModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: (message: string) => void;
  onError?: (message: string) => void;
  onLoading?: (loading: boolean) => void;
}

export function QuickDisableDayModal({
  open,
  onClose,
  onSuccess,
  onError,
  onLoading,
}: QuickDisableDayModalProps) {
  const [date, setDate] = useState("");
  const [localError, setLocalError] = useState("");

  const handleDisable = () => {
    if (!date) {
      setLocalError("Please select a date.");
      return;
    }
    setLocalError("");
    onLoading?.(true);
    apiSubscribe<ApiMessageResponse>(
      disableBookingDate(date),
      {
        next: (body) => {
          onLoading?.(false);
          if (body?.status === "success") {
            setDate("");
            onClose();
            onSuccess?.("Date disabled successfully.");
          } else {
            const msg = "Could not disable date.";
            onError?.(msg);
            setLocalError(msg);
          }
        },
        error: () => {
          onLoading?.(false);
          const msg = "Could not reach server.";
          onError?.(msg);
          setLocalError(msg);
        },
      }
    );
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Disable booking"
      description="Close appointments for a specific date."
      footer={
        <ModalFooter>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDisable}>
            Disable
          </Button>
        </ModalFooter>
      }
    >
      {localError && (
        <Alert variant="error" className="mb-3">
          {localError}
        </Alert>
      )}
      <Input label="Date" type="date" value={date} onChange={(e) => setDate(e.target.value)} />
    </Modal>
  );
}
